import { locale } from "../../../utils/formatters/toWSDate";

export function formatDate(value: Date, showTime = false) {
  const dayFormatted = value.toLocaleString(locale, {
    day: "2-digit"
  });

  const monthFormatted = value.toLocaleString(locale, {
    month: "2-digit"
  });

  const yearFormatted = formatYear(value.getFullYear());

  const dateStr = `${yearFormatted}-${monthFormatted}-${dayFormatted}`;

  if (!showTime) {
    return dateStr;
  }

  const hoursFormatted = value.toLocaleString(locale, {
    hour: "2-digit",
    hour12: false
  });

  const minutesFormatted = value.toLocaleString(locale, {
    minute: "2-digit"
  });

  return `${dateStr}T${hoursFormatted}:${minutesFormatted}`;
}

export function formatYear(year: number) {
  if (year < 10) {
    return `000${year}`;
  } else if (year < 100) {
    return `00${year}`;
  } else if (year < 1000) {
    return `0${year}`;
  } else {
    return `${year}`;
  }
}
